

function getBigScreenUrl(page:string) {

    return "/server/" + page;
}

export const BigScreenSplash = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20Splash.png");
export const BigScreenLogin = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20LogIn.png");
export const BigScreenWelcome = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20Welcome.png");

export const BigScreenAboutOn2 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20About%20Us.png");
export const BigScreenLendingServices = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20Lending%20Services.png");
export const BigScreenAboutCommunity = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20On2%20at%20GVR.png");
export const BigScreenAboutCompany = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20About%20Oakwood%20Homes.png");
export const BigScreenAboutCompanyInvolvement = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20New%20And%20Resale%20Closings%20Bell%20Graph.png");


export const BigScreenHomeBuyersClub = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20Homebuyers%20Club.png");

export const BigScreenHomeBuildingProcess1 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%201.png");
export const BigScreenHomeBuildingProcess2 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%202.png");
export const BigScreenHomeBuildingProcess3 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%203.png");
export const BigScreenHomeBuildingProcess4 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%204.png");
export const BigScreenHomeBuildingProcess5 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%205.png");
export const BigScreenHomeBuildingProcess6 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%206.png");
export const BigScreenHomeBuildingProcess7 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%207.png");
export const BigScreenHomeBuildingProcess8 = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20HBP%208.png");

export const BigScreenSavedHomesSaved = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20Saved%20Homes.png");
export const BigScreenSavedHomesNothingSaved = getBigScreenUrl("StaticContent.html?image=Big%20Screen%20-%20Nothing%20Saved.png");

export const BigScreenQuiz1 = getBigScreenUrl("StaticContent.html?image=Big Screen - Question 1.png");
export const BigScreenQuiz2 = getBigScreenUrl("StaticContent.html?image=Big Screen - Question 2.png");
export const BigScreenQuiz3 = getBigScreenUrl("StaticContent.html?image=Big Screen - Question 3.png");
export const BigScreenQuizComplete = getBigScreenUrl("StaticContent.html?image=Big Screen - Quiz Complete.png");

export function getQuizURL(imageId: number) {
    const mapping: Record<number, string> = {
        1: BigScreenQuiz1,
        2: BigScreenQuiz2,
        3: BigScreenQuiz3,
        4: BigScreenQuizComplete
    };

    return mapping[imageId];
}
